import React from 'react'
import {Slider} from 'antd';
import injectSheet from 'react-jss'

const marks = {
  0: '0°C',
  44: '882°C',
  83: '1668°C'
};

class Titanium extends React.Component {
  constructor(props) {
    super(props);
    this.state = {val: 0};
  }

  render() {
    let opacity1 = (54 - this.state.val) * 0.05;
    let phase1 = (opacity1 > 0.5) ? 'block' : 'none';
    let phase2 = (opacity1 <= 0.5) ? 'block' : 'none';
    let opacity3 = (-73 + this.state.val) * 0.05;
    let phase3 = (opacity3 > 0.5) ? 'block' : 'none';
    let style = opacity1 < 0.5 ? this.props.classes.slider_yellow : this.props.classes.slider_blue;
    if (opacity3 >= 0.5) style = this.props.classes.slider_red;

    return (
      <div style={{width: '100%', height: 600}}>
        <div style={{width: '100%', height: 320, position: 'relative'}}>
          <div id="container-01"
               style={{height: '100%', width: '100%', position: 'absolute', fontSize: 100, display: phase1}}></div>
          <div id="container-02"
               style={{height: '100%', width: '100%', position: 'absolute', fontSize: 100, display: phase2}}></div>
          <div id="container-03"
               style={{height: '100%', width: '100%', position: 'absolute', fontSize: 100, display: phase3}}></div>
        </div>
        <Slider className={this.props.classes.slider + ' ' + style} marks={marks} defaultValue={this.state.val}
                tipFormatter={null} onChange={(e) => {
          this.setState({val: e});
        }}/>
      </div>)
  }
}

const styles = {
  slider_red: {
    '& .ant-slider-dot:first-child, .ant-slider-track': {
      backgroundColor: '#f5222d !important',
    },
    '&:hover .ant-slider-track': {
      backgroundColor: '#ff7875 !important'
    }
  },
  slider_yellow: {
    '& .ant-slider-dot:first-child, .ant-slider-track': {
      backgroundColor: '#faad14 !important',
    },
    '&:hover .ant-slider-track': {
      backgroundColor: '#ffd666 !important'
    }
  },
  slider: {
    '& .ant-slider-dot:first-child, .ant-slider-track': {
      backgroundColor: '#1890ff',
      transition: 'background-color ease 1s',
    },
    '& .ant-slider-handle': {
      display: 'none'
    },
    '& .ant-slider-dot': {
      border: 'none',
      '&:not(:first-child)': {
        opacity: 0.5,
      },
      '&:first-child': {
        height: 32,
        width: 32,
        top: -14,
        marginLeft: -16,
        zIndex: 2
      }
    },
    '& .ant-slider-rail, .ant-slider-track': {
      borderRadius: 8,
      height: 16,
      marginTop: -6
    },
    '& .ant-slider-mark': {
      top: 28
    }
  }
};

export default injectSheet(styles)(Titanium)



// WEBPACK FOOTER //
// ./src/components/titanium.js